import { Alert } from '@brokerbay/design-components';
import * as React from 'react';
import Icon from '../../Icon';
import theme from '../../theme';

export interface OverAlertProps {
  variant: 'noAccess';
}

const OverAlert: React.FC<OverAlertProps> = ({ variant }) => {
  switch (variant) {
    case 'noAccess':
      return (
        <Alert
          dataCy="noAccess-page-alert"
          message={
            <span>
              You do not have access to this feature. Please reach out to your
              managing broker to finish setting up your brokerage.
            </span>
          }
          type="warning"
          showIcon
          icon={
            <Icon
              type="antdExclamationCircleFilled"
              color="warning"
              width={14}
            />
          }
        />
      );

    default:
      throw new Error(`Unsupported ${variant}`);
  }
};

export default OverAlert;
